import { SET_SHARE_DETAIL } from "../types/share"

export const setSocialShareDetail = shareDetail => dispatch => {
    dispatch({
        type    :   SET_SHARE_DETAIL,
        payload :   shareDetail
    })
}
